export default __webpack_public_path__ + "static/media/hedgehog.1d2e410e.png";